import { MenuService } from './menu.service';
import { ProductCustomizationService } from './product-customization.service';
import { AccessibilityService } from './accessibility.service';

export const services = [MenuService, ProductCustomizationService, AccessibilityService];

export * from './menu.service';
export * from './product-customization.service';
export * from './accessibility.service';
